__turbopack_context__.v({
  "optionRow": "SstJiW_optionRow",
  "outOfStockTag": "SstJiW_outOfStockTag",
  "productName": "SstJiW_productName",
  "radioButton": "SstJiW_radioButton",
  "row": "SstJiW_row",
  "singleLineText": "SstJiW_singleLineText",
  "spaceBetween": "SstJiW_spaceBetween",
  "titleRow": "SstJiW_titleRow",
  "warningText": "SstJiW_warningText",
});
